import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as Api from '../api';
import * as Types from '../types';

const SESSIONS_KEY = ['auth', 'sessions'] as const;

/** The caller's active sessions (device, IP, login time), most-recent first. */
export const useSessions = () =>
  useQuery<Types.IApi.Sessions.Response>({
    queryKey: SESSIONS_KEY,
    queryFn: async () => {
      const { data } = await Api.GetSessions();
      return data;
    },
  });

/** Revoke a single session (sign out one device); refreshes the list. */
export const useRevokeSession = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await Api.RevokeSession(id);
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: SESSIONS_KEY }),
  });
};

/** Revoke every session except the current one; refreshes the list. */
export const useRevokeOtherSessions = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const { data } = await Api.RevokeOtherSessions();
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: SESSIONS_KEY }),
  });
};
